import React from 'react';

import Map from './../components/Map.js';

const InteractiveMap = () => <Map />;

export default InteractiveMap;



// WEBPACK FOOTER //
// ./src/screens/InteractiveMap.js